





























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import NoticeTemplate from '@/components/Notices/NoticeTemplate.vue'
import Modal from '@/components/Modal.vue'
import { ModalSize } from '@/components/modal-size'
import { embedded, postMessageToRNWebView } from '@/utils/react-native-webview'
import { respondToNotice } from '@/api/notices'

@Component<NoticeStack>({
    components: { Modal, NoticeTemplate }
})
export default class NoticeStack extends Vue {
    @Prop({ type: Boolean, default: false }) public disableDrag!: boolean
    @Prop({ type: Boolean, default: true }) public readonly loading!: boolean
    @Prop({ type: String, default: '0' }) public readonly id!: string

    @Getter public readonly getNotices

    @Action public loadNotifications
    @Action public removeNotification

    private modalSize = ModalSize
    private noticesRead: number[] = []
    private loaded = false
    private forceClosed = false

    public get getRemainingNotices() {
        return this.getNotices.filter(n => !this.noticesRead.includes(n.id))
    }

    public async mounted() {
        const unixTimestamp = Math.ceil(new Date().getTime() / 1000)
        await this.loadNotifications({
            last_polled: unixTimestamp,
            first_notification_id: parseInt(this.id)
        })
        this.loaded = true
        this.goBackIfNoRemainingNotices()
    }

    @Watch('getRemainingNotices')
    private goBackIfNoRemainingNotices() {
        if (this.loaded && embedded && this.getRemainingNotices.length === 0) {
            postMessageToRNWebView({
                action: 'back'
            })
        }
    }

    private removeNoticeByNoticeId(noticeId: number) {
        this.noticesRead.push(noticeId)
        const notice = this.getNotices.findIndex(n => n.id === noticeId)
        this.removeNotification(this.getNotices.indexOf(notice))

        this.goBackIfNoRemainingNotices()
    }

    private closeAllNotices() {
        for (const notice of this.getNotices) {
            if (notice.id) {
                this.removeNoticeByNoticeId(notice.id)
            }
            if (notice.noticesrecipient_id) {
                respondToNotice(notice.noticesrecipient_id, 'close', '')
            }
        }

        this.forceClosed = true
    }
}
